import { useTranslations } from 'next-intl';
import { GlowTag, GlowTextBody } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';
import { UserSephoraCardType } from '../../../../server';
import { FidIcon } from '../../loyalty';

type PushLoyaltyCTAContentProps = {
    userCard?: UserSephoraCardType;
    customerFirstName: string;
    loyaltyPointsLabel: string;
    isMySephoraActivated: boolean;
};

export const PushLoyaltyCTAContent: Component<PushLoyaltyCTAContentProps> = ({
    userCard,
    customerFirstName,
    loyaltyPointsLabel,
    isMySephoraActivated,
}) => {
    const discoverT = useTranslations('Discover.Pdp.loyalty');
    const commonT = useTranslations('Modal.pushLoyalty.mySephora');

    return (
        <div className={'flex flex-row gap-0.5 w-full text-text-primary'}>
            <div className={'flex justify-center items-center'}>
                <FidIcon userCard={userCard} isMySephoraActivated={isMySephoraActivated} isRequired />
            </div>

            <div className={'flex flex-col gap-0.5 text-left'}>
                <GlowTextBody
                    text={isMySephoraActivated ? commonT('label.programName') : discoverT('label.fidAdvantage')}
                    fontWeight={'bold'}
                />
                <div className={'flex flex-col gap-0.25'}>
                    <div className={'flex flex-row gap-x-0.5 items-center'}>
                        <GlowTextBody text={customerFirstName} />
                        <GlowTag
                            label={loyaltyPointsLabel}
                            color={isMySephoraActivated ? 'primaryGreen' : 'primaryGrey'}
                            size={'large'}
                        />
                    </div>

                    <GlowTextBody text={discoverT('label.fidText')} />
                </div>
            </div>
        </div>
    );
};
